import { render, staticRenderFns } from "./OrderList.vue?vue&type=template&id=5330397a"
import script from "./OrderList.js?vue&type=script&lang=js&external"
export * from "./OrderList.js?vue&type=script&lang=js&external"
import style0 from "./OrderList.vue?vue&type=style&index=0&id=5330397a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports